import React from "react";

const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message }) => {
    if (!isOpen) return null;

    return (
        <div className="absolute h-full inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 overflow-hidden">
            <div className="bg-white dark:bg-[#1a1a1a] p-4 rounded-lg shadow-lg w-[85%]">
                <h2 className="text-[18px] font-bold text-black dark:text-white mb-2">{title}</h2>
                <p className="text-gray-600 dark:text-gray-400 mb-4 text-[12px] md:text-[14px]">
                    {message}
                </p>
                <div className="grid grid-cols-12 justify-center text-center gap-2 sm:gap-3 md:gap-4">
                    <button
                        className="rounded-full w-full col-span-6 bg-[#151515] hover:bg-[#272727] text-center text-[10px] sm:text-[11px] md:text-[12px] font-bold px-6 sm:px-8  h-6 sm:h-7 md:h-8 text-[#fff]"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="rounded-full w-full col-span-6 text-[10px] sm:text-[11px] md:text-[12px] text-center px-6 sm:px-8  h-6 sm:h-7 md:h-8 bg-[#BDE6FF] font-bold hover:bg-[#9dd4f0] text-black"
                        onClick={onConfirm}
                    >
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
